export const UserListMutations = {
    SET_FILTER_OPTION: 'SET_FILTER_OPTION',
    SET_SORT_OPTION: 'SET_SORT_OPTION',
    GET_USER_LIST: 'GET_USER_LIST',
};
